import { NewColor } from '../models/color.model';

export const newColors: NewColor[] = [
  {
    name: 'Grey',
    subColors: [
      {
        name: 'Grey 1',
        color: '#F9F9FA'
      },
      {
        name: 'Grey 2',
        color: '#DCDBE0'
      },
      {
        name: 'Grey 3',
        color: '#A3A1B0'
      },
      {
        name: 'Grey 4',
        color: '#494465'
      },
      {
        name: 'Grey 5',
        color: '#2D2C34'
      },
      {
        name: 'White',
        color: '#FFFFFF',
        border: true
      }
    ]
  },
  {
    name: 'Red',
    subColors: [
      {
        name: 'Pale',
        color: '#FFE5E6'
      },
      {
        name: 'Lighter',
        color: '#FFBABD'
      },
      {
        name: 'Light',
        color: '#FC5359'
      },
      {
        name: 'Main',
        color: '#E31E25'
      },
      {
        name: 'Darker',
        color: '#B0171D'
      }
    ]
  },
  {
    name: 'Blue',
    subColors: [
      {
        name: 'Pale',
        color: '#E5EEFF'
      },
      {
        name: 'Lighter',
        color: '#B0CCFF'
      },
      {
        name: 'Light',
        color: '#608FE5'
      },
      {
        name: 'Main',
        color: '#2C6DE5'
      },
      {
        name: 'Dark',
        color: '#2761CC'
      }
    ]
  },
  {
    name: 'Green',
    subColors: [
      {
        name: 'Pale',
        color: '#E5FFF5'
      },
      {
        name: 'Lighter',
        color: '#B8E7D4'
      },
      {
        name: 'Light',
        color: '#3EC991'
      },
      {
        name: 'Main',
        color: '#14AF70'
      },
      {
        name: 'Dark',
        color: '#119660'
      }
    ]
  },
  {
    name: 'Yellow',
    subColors: [
      {
        name: 'Pale',
        color: '#FFF7E5'
      },
      {
        name: 'Lighter',
        color: '#FFEFCC'
      },
      {
        name: 'Light',
        color: '#FDD479'
      },
      {
        name: 'Main',
        color: '#FDC448'
      },
      {
        name: 'Dark',
        color: '#E3B041'
      }
    ]
  },
  {
    name: 'Highlight',
    subColors: [
      {
        name: 'Pale',
        color: '#FDEBE0'
      },
      {
        name: 'Lighter',
        color: '#FAE3D4'
      }
    ]
  },
  {
    name: 'GRI',
    subColors: [
      {
        name: 'Utility Pale',
        color: '#CDDDEC'
      },
      {
        name: 'Utility Main',
        color: '#0356A1'
      },
      {
        name: 'Topic Pale',
        color: '#E3D5E8'
      },
      {
        name: 'Topic Main',
        color: '#712B8E'
      },
      {
        name: 'Universal Pale',
        color: '#D1EBE4'
      },
      {
        name: 'Universal Main',
        color: '#1B9C77'
      },
      {
        name: 'Sector Pale',
        color: '#FDE3D4'
      },
      {
        name: 'Sector Main',
        color: '#F3722A'
      }
    ]
  },
  {
    name: 'ISO',
    subColors: [
      {
        name: 'Pale',
        color: '#EBD5D9'
      },
      {
        name: 'Main',
        color: '#9C2B42'
      }
    ]
  },
  {
    name: 'TCFD',
    subColors: [
      {
        name: 'Pale',
        color: '#E5EEFF'
      },
      {
        name: 'Main',
        color: '#2C6DE5'
      }
    ]
  },
  {
    name: 'Documentation',
    subColors: [
      {
        name: 'Pale',
        color: '#BFFFFF'
      },
      {
        name: 'Main',
        color: '#00FFFF'
      }
    ]
  }
];
